import { inject, Injectable } from '@angular/core';
import { SettingsService } from '../settings/settings.service';
import { Permission, RoleAuthorization } from '@shared/models/settings/role-authorisation';
import Keycloak from 'keycloak-js';

@Injectable({
    providedIn: 'root'
})
export class AuthorizationService {
    private _filteredMatrix: RoleAuthorization[] = [];

    private keycloak: Keycloak;
    private settingsService: SettingsService;

    constructor(
    ) {
        this.keycloak = inject(Keycloak);
        this.settingsService = inject(SettingsService);
    }

    get roles(): string[] {
        try {
            let roles: string[] = [];
            if (this.keycloak.realmAccess?.roles) {
                roles = roles.concat(this.keycloak.realmAccess.roles);
            }
            if (this.keycloak.resourceAccess) {
                Object.values(this.keycloak.resourceAccess).forEach(access => {
                    if (access.roles) {
                        roles = roles.concat(access.roles);
                    }
                });
            }
            return roles;
        } catch (e) {
            console.error('Error fetching roles', e);
            return [];
        }
    }

    get isSysOp(): boolean {
        return this.roles.includes('sysop');
    }

    actionAllowed(component: string): boolean {
        const hasComponent = this._filteredMatrix.find(matrix => matrix.component === component);
        return hasComponent?.permission === Permission.READWRITE;
    }

    hasComponentAccess(component: string, permission: Permission = Permission.READWRITE): Promise<boolean> {
        let roles = this.roles;
        if (this.roles.length > 1) {
            const admin = this.roles.find(value => value === 'admin');
            if (admin) {
                roles = [admin];
            }
        }

        return this.settingsService.roleAuthorizations.then(roleAutoriszations => {
            this._filteredMatrix = roleAutoriszations.filter(items => roles.includes(items.role));
            const userAccessComponent = this._filteredMatrix.find(matrix => matrix.component === component);
            if (userAccessComponent?.permission === Permission.READWRITE) {
                // Users permission equals READWRITE and READ permission on component gets ignored
                return true;
            } else {
                // Users permissions equals the requested permission on the component
                return userAccessComponent?.permission === permission;
            }
        });
    }
}
